/*
 * Params:
 * inputs, page (0 based), size
 */
import { clientFetch } from '../clientFetch';

export const sitemapSearch = (page) => {
  return clientFetch(`/doctor-sitemap/${page}`);
};

export const sitemapGetPagination = () => {
  return clientFetch('/doctor-sitemap');
};
